import React, { useState } from "react";
import Login from "./Login";
import ArticleForm from "./ArticleForm";
import EventForm from "./EventForm";

function AdminPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Handles authentication
  const handleAuth = (password) => {
    if (password === "admin123") { // Replace with a secure mechanism in production
      setIsAuthenticated(true);
    } else {
      alert("Invalid password! Please try again.");
    }
  };

  if (!isAuthenticated) {
    return <Login onAuthenticate={handleAuth} />;
  }

  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h2 style={{ textAlign: "center", marginBottom: "2rem" }}>Admin Dashboard</h2>
      
      <div style={{ marginBottom: "3rem" }}>
        <ArticleForm />
      </div>

      <div>
        <EventForm />
      </div>
    </div>
  );
}

export default AdminPage;
